import { PageHeader } from "components/pageHeader";
import { CommunicationSequencesTabs } from "features/communicationSequencesTabs";
import Content from "layouts/agencyPortal/dashboard/content";
import PageLayout from "layouts/agencyPortal/dashboard/pageLayout";

function SequencesPage() {
  return (
    <PageLayout>
      <Content>
        <PageHeader>Communication Sequences</PageHeader>
        <CommunicationSequencesTabs />
      </Content>
    </PageLayout>
  );
}

export default SequencesPage;
